import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'pendenciesText',
})
export class PendenciesTextPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(value: number, isSurvey = false): any {
    if (value > 1) {
      return isSurvey
        ? `${value} ${this.translate.instant('SURVEYS.NEW_SURVEY.PENDING_INSPECTIONS')}`
        : `${value} ${this.translate.instant('SURVEYS.NEW_SURVEY.PENDINGS')}`;
    } else if (value === 1) {
      return isSurvey
        ? `${value} ${this.translate.instant('SURVEYS.NEW_SURVEY.PENDING_INSPECTION')}`
        : `${value} ${this.translate.instant('SURVEYS.NEW_SURVEY.PENDINGS')}`;
    } else {
      return this.translate.instant('SURVEYS.NEW_SURVEY.NO_PENDING');
    }
  }
}
